module.exports = __webpack_public_path__ + "img/scenario-plan.808d9e58.svg";